import withLayout from 'apps/web-client/src/hoc/with-layout';

import SearchResultController from './search-result.controller';

const SearchResultScreen: React.FC = () => {
  return <SearchResultController />;
};

export default withLayout(SearchResultScreen);
